module.exports = __webpack_public_path__ + "static/media/21.db600d3d.jpg";